import { Text } from "@zapier/design-system";
import { useTranslations } from "next-intl";
import styles from "./Hero.module.css";

export const Hero = () => {
  const t = useTranslations("Homepage");
  return (
    <div className={styles.hero}>
      <div className={styles.heroContent}>
        <div className={styles.heroText}>
          <Text
            type="PageHeader"
            tag="h1"
            className={styles.title}
            color="TextDefault"
          >
            {t("heroTitle")}
          </Text>
          <Text type="ParagraphHeader1" color="GrayWarm9">
            {t("heroDescription")}
          </Text>
        </div>
      </div>
    </div>
  );
};
